import { render, staticRenderFns } from "./seo-content-accordion.vue?vue&type=template&id=2f7e84c2&scoped=true&"
import script from "./seo-content-accordion.vue?vue&type=script&lang=js&"
export * from "./seo-content-accordion.vue?vue&type=script&lang=js&"
import style0 from "./seo-content-accordion.vue?vue&type=style&index=0&id=2f7e84c2&lang=scss&scoped=true&"
import style1 from "./seo-content-accordion.vue?vue&type=style&index=1&id=2f7e84c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e84c2",
  null
  
)

export default component.exports